module.exports = {["template-constructor-workspace-inside-block"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="workspace-inside-block">\n		<div class="blocks-wrapper"></div>\n	</div>\n\n';
}
return __p;
},}